import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a53aa28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-breaches-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Add breach")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "List of breaches", -1))
const _hoisted_4 = { class: "search-inputs" }
const _hoisted_5 = { class: "search-bar" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-filter fa-lg" })
], -1))
const _hoisted_7 = { class: "checkbox-button ml-2 mr-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Rule breaches")
], -1))
const _hoisted_9 = { class: "checkbox-button ml-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Law breaches")
], -1))
const _hoisted_11 = { class: "ls-table" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { "data-label": "Name" }
const _hoisted_23 = { "data-label": "Breach code" }
const _hoisted_24 = { "data-label": "Legislation" }
const _hoisted_25 = { "data-label": "Description" }
const _hoisted_26 = { "data-label": "Action" }
const _hoisted_27 = ["disabled", "onUpdate:modelValue"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ])
], -1))
const _hoisted_29 = { class: "controls mt-4" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      halfScreen: false,
      onClose: _cache[5] || (_cache[5] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
              key: 0,
              class: "loading-indicator",
              showLoadingText: false
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
                    placeholder: "Filter breaches by keyword"
                  }, null, 512), [
                    [_vModelText, _ctx.searchKeyword]
                  ]),
                  _hoisted_6
                ]),
                _createElementVNode("label", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showRuleBreachesOnly) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showRuleBreachesOnly]
                  ]),
                  _hoisted_8
                ]),
                _createElementVNode("label", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showLawBreachesOnly) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showLawBreachesOnly]
                  ]),
                  _hoisted_10
                ])
              ]),
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                        onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(h.text), 1),
                          (h.sortable)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                              }, _hoisted_15, 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_12))
                    }), 256))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.loadingContent)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _createElementVNode("td", {
                          colspan: _ctx.tableHeadings.length
                        }, [
                          _createVNode(_component_LoadingIndicator)
                        ], 8, _hoisted_17)
                      ]))
                    : (_ctx.errorLoadingContent)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                          _createElementVNode("td", {
                            colspan: _ctx.tableHeadings.length
                          }, [
                            _createVNode(_component_ErrorIndicator)
                          ], 8, _hoisted_19)
                        ]))
                      : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.breachesListDisplay.length == 0  && _ctx.searchKeyword.length > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                            _createElementVNode("td", {
                              colspan: _ctx.tableHeadings.length
                            }, "No Records", 8, _hoisted_21)
                          ]))
                        : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.breachesListDisplay.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.applyFilter(_ctx.breachesListDisplay), (b) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", _hoisted_22, _toDisplayString(b.type), 1),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(b.breachCode), 1),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(b.legislation), 1),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(b.description), 1),
                                _createElementVNode("td", _hoisted_26, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["checkbox-button", _ctx.isDuplicated(b.refNumber) ? 'disabled' : ''])
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      disabled: _ctx.isDuplicated(b.refNumber),
                                      "onUpdate:modelValue": $event => ((b.isSelected) = $event)
                                    }, null, 8, _hoisted_27), [
                                      [_vModelCheckbox, b.isSelected]
                                    ]),
                                    _hoisted_28
                                  ], 2)
                                ])
                              ]))
                            }), 256))
                          : _createCommentVNode("", true)
                ])
              ])
            ], 64))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-outline",
            disabled: _ctx.submitting,
            onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, " Cancel ", 8, _hoisted_30),
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            disabled: _ctx.submitting,
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.submit()), ["prevent","stop"]))
          }, " Add ", 8, _hoisted_31)
        ])
      ]),
      _: 1
    })
  ]))
}